// src/hooks/useTags.js
import { useCallback, useEffect, useState } from "react";
import { useTagsApi } from "../api/tagsApi";

export const useTags = () => {
  const api = useTagsApi();
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTags = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAll();
      setTags(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addTag = async (tagData) => {
    const newTag = await api.create(tagData);
    setTags((prev) => [...prev, newTag]);
  };

  const updateTag = async (id, tagData) => {
    const updatedTag = await api.update(id, tagData);

    setTags((prev) =>
      prev.map((tag) => (tag.id === id ? { ...tag, ...updatedTag } : tag)),
    );
  };

  const deleteTag = async (id) => {
    await api.remove(id);
    setTags((prev) => prev.filter((tag) => tag.id !== id));
  };

  useEffect(() => {
    fetchTags();
  }, [fetchTags]);

  return {
    tags,
    loading,
    error,
    fetchTags,
    addTag,
    updateTag,
    deleteTag,
  };
};
